import { createObjectSchema, createRecordSchema, createStringSchema } from '@dreryk/react-draft';

import { DocumentTemplateFormBean } from '~libs.desktop.shared.document-template';

export const consentTemplateDraftSchema = createObjectSchema<DocumentTemplateFormBean>({
   documentTemplateValues: createRecordSchema(createStringSchema()),
});

type VisitId = number;
type PrintTemplateId = number;
export type ConsentTemplateDraftToken = 'consentTemplate';
export const getConsentTemplateDraftToken = (
   visitId: VisitId,
   printTemplateId: PrintTemplateId
): `visit-${VisitId}-${ConsentTemplateDraftToken}-${PrintTemplateId}` =>
   `visit-${visitId}-consentTemplate-${printTemplateId}`;
